<template>
  <div class="settings-inner-box">
    <div class="clearfix">
      <p class="settings-heading">Partnerships</p>
      <p class="close-icon" @click="close">
        <img src="~@/assets/img/close.svg" alt="close" class="icon" aria-label="close"/>
      </p>
    </div>
    <p class="content-text">Ragya invites Indian classical musicians, archives and
     storehouses of Indian classical music who may want to make their own treasures
      available to the listeners of Ragya worldwide. For more information,
      <a href="mailto:contact@ragya.com " title="mailto">get in touch</a> with us.
    </p>
  </div>
</template>

<script>
import Utils from '../mixins/utils';

export default {
  name: 'Partnerships',
  mixins: [Utils],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
